export default function errorBlock(type, pageName) {
  return {
    error_type: type,
    current_pagename: pageName
  };
};
